import React, { ChangeEvent, useState } from 'react';

import BackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

interface SearchTextFieldProps {
  noLabel?: boolean;
  width?: string;
  value?: string;
  onSearch: (text: string) => void;
  onReturn?: () => void;
}

const SearchTextField = (props: SearchTextFieldProps) => {
  const [value, setValue] = useState(props?.value || '');

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    props.onSearch(e.target.value);
  };

  const onClear = () => {
    setValue('');
    props.onSearch('');
  };

  return (
    <TextField
      id="input-with-icon-textfield"
      sx={{
        minWidth: 120,
        width: props.width || 'auto',
        margin: props.noLabel ? '0' : 'default'
      }}
      size="small"
      variant="outlined"
      margin="dense"
      label={props.noLabel ? '' : 'Search'}
      disabled={!!props?.value}
      value={value}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {props?.value ? (
              <IconButton onClick={props?.onReturn}>
                <BackIcon />
              </IconButton>
            ) : (
              <IconButton
                sx={
                  value ? { visibility: 'visible' } : { visibility: 'hidden' }
                }
                onClick={onClear}
              >
                <CloseIcon />
              </IconButton>
            )}
          </InputAdornment>
        )
      }}
      onChange={onChange}
    />
  );
};

export default SearchTextField;
